/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import styled, { css } from 'styled-components'

import FlexBox from 'src/components/Common/FlexBox'
import Icon from 'src/components/Icon'
import { useThemeContext } from 'src/contexts/ThemeContext'
import { pxToVw } from 'src/functions/units'

type Props = {
  hidden?: boolean
}

const ModalV2Footer = ({ hidden = false }: Props) => {
  const { colors } = useThemeContext()

  if (hidden) return null

  return (
    <StyledDialogFooter>
      <small>Upon any doubts, be sure to check the main project page.</small>
      <a href="https://thegoodblockchain.sg/" target="_blank" rel="noreferrer">
        <FlexBox as="span" columnGap={4} alignItems="center">
          <span>The Good Blockchain</span>
          <Icon icon="caret-right" size={12} color={colors.primary600} />
        </FlexBox>
      </a>
    </StyledDialogFooter>
  )
}

export default ModalV2Footer

const StyledDialogFooter = styled.div`
  width: 100%;
  margin-top: ${pxToVw(30)};
  padding-block: ${pxToVw(40)};
  border-top: solid 1px ${({ theme }) => theme.colors.gray200};

  small {
    display: block;
    font-size: ${pxToVw(18)};
    color: ${({ theme }) => theme.colors.gray};
    margin-bottom: ${pxToVw(12)};
  }

  a,
  a:visited {
    font-size: ${pxToVw(22)};
    font-weight: 500;
    color: ${({ theme }) => theme.colors.primary600};
  }

  ${({ theme }) => css`
    ${theme.mediaQuery.mobile`
      margin-top: ${pxToVw(30, 720)};
      padding-block: ${pxToVw(40, 720)};

      small {
        font-size: ${pxToVw(18, 720)};
        margin-bottom: ${pxToVw(12, 720)};
      }

      a, a:visited {
        font-size: ${pxToVw(22, 720)};
      }
    `}
  `}
`
